<template>
  <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="auto" class="demo-ruleForm">

    <el-form-item prop="pass">
      <el-input :maxlength='20' type="password" placeholder="请输入密码" v-model="ruleForm.pass" autocomplete="off">
        <i slot="prefix" class="el-input__icon el-icon-lock">
        </i>
      </el-input>
    </el-form-item>

    <el-form-item prop="checkPass">
      <el-input type="password" placeholder="请再次输入密码" v-model="ruleForm.checkPass" autocomplete="off">
        <i slot="prefix" class="el-input__icon el-icon-lock">
        </i>
      </el-input>
    </el-form-item>

    <el-form-item class="form_item_btn">
      <el-button class="btn_submit" @click="submitForm('ruleForm')">完成</el-button>
    </el-form-item>

  </el-form>
</template>

<script>
import { reset } from "@/network/loginRequest/api";
import md5 from "js-md5";
import utils from "@/util/index";

export default {
  data() {
    var validatePass = (rule, value, callback) => {
      //验证密码
      let RegBlank = new RegExp(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{6,16}$|^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{6,16}$|^(?=.*[a-z])(?=.*[A-Z])(?=.*[$@$!%*#?&])[a-zA-Z$@$!%*#?&]{6,16}$/
      );
      if (!RegBlank.test(value)) {
        callback(
          new Error(
            "密码至少包含字母、数字、特殊字符（!@#$%^&*()_+）中的三种，长度为6-16"
          )
        );
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        pass: "",
        checkPass: ""
      },
      rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let fd = new FormData();
          fd.append("password", md5(this.ruleForm.checkPass));
          fd.append("telephone", this.$bus.resetFrom.telephone);
          fd.append("vCode", this.$bus.resetFrom.code);
          reset(fd).then(res => {
            if (res.data.success) {
              this.$emit("update:showName", 2);
            } else {
              utils.tips("error", res.data.code);
            }
          });
        } else {
          utils.tpis("error", "请确保按照规则填写密码");
          return false;
        }
      });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
      console.log(123);
    }
  }
};
</script>

<style lang='less' scoped>
.el-form {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .form_item_btn {
    margin-top: 10px;
  }

  .el-form-item:nth-child(3) {
    margin-bottom: 10px;
  }

  .el-form-item {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 30px;

    .btn_submit {
      width: 100%;
      color: #fff;
      background-color: #24ba58;
      border-color: #24ba58;
      margin: 20px 0 10px;
    }

    .el-button--success:active {
      background-color: skyblue;
      border-color: skyblue;
    }

    /deep/.el-input__inner:focus {
      border-color: #24ba58;
    }
  }
}
</style>